var _circle, _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgJavascript1(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 70.6 70.6",
    enableBackground: "new 0 0 70.6 70.6",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 35.3,
    cy: 35.3,
    r: 35,
    fill: "#fadf1c"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "#393532"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m20.7 51.8c-1.5 0-3.4-.3-4.6-.8l-.4-.2.8-4.2.6.2c.9.4 2.1.6 3.3.6 3.2 0 5.3-1.2 5.3-7.1v-20.5h5.1v20.9c0 7.3-3.4 11.1-10.1 11.1"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m30.3 20.3v20.4c0 8.1-4.1 10.6-9.6 10.6-1.5 0-3.3-.3-4.4-.7l.6-3.2c.8.3 2.1.6 3.4.6 3.7 0 5.8-1.6 5.8-7.6v-20.1h4.2m1-1h-1-4.1-1v1 20.1c0 5.5-1.8 6.6-4.8 6.6-1.5 0-2.7-.4-3.1-.5l-1.2-.5-.2 1.2-.6 3.2-.2.8.8.3c1.2.5 3.1.8 4.7.8 7 0 10.6-3.9 10.6-11.6v-20.4-1h.1z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m42.9 51.7c-2.9 0-6.1-.8-7.9-2l-.3-.2 1.3-4.2.6.3c1.9 1.2 4.4 1.9 6.6 1.9 3.5 0 5.7-1.8 5.7-4.6 0-2.5-1.4-4-5.3-5.5-5.6-2-8.2-4.8-8.2-9 0-5.1 4.2-8.7 10.1-8.7 3.6 0 5.8 1 6.8 1.5l.4.2-1.4 4.1-.5-.3c-1.1-.6-3-1.4-5.4-1.4-3.5 0-5.1 2-5.1 4 0 2.4 1.4 3.7 5.6 5.3 5.5 2.2 7.9 4.9 7.9 9.3 0 4.4-2.9 9.3-10.9 9.3"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m45.5 20.3c3 0 5.3.7 6.6 1.5l-1.1 3.1c-1-.5-3-1.4-5.6-1.4-4.1 0-5.6 2.5-5.6 4.5 0 2.8 1.8 4.2 5.9 5.8 5 2 7.6 4.4 7.6 8.8 0 4.6-3.4 8.6-10.4 8.6-2.9 0-6-.8-7.6-1.9l1-3.3c1.7 1.1 4.2 2 6.9 2 3.9 0 6.2-2.1 6.2-5.1 0-2.8-1.6-4.4-5.6-6-4.9-1.7-7.9-4.3-7.9-8.5 0-4.6 3.8-8.1 9.6-8.1m0-1c-6.3 0-10.6 3.8-10.6 9.2 0 4.3 2.8 7.4 8.5 9.4 4.1 1.6 4.9 3.1 4.9 5 0 2.6-2 4.1-5.2 4.1-2.2 0-4.5-.7-6.4-1.8l-1.1-.7-.4 1.3-1 3.3-.2.7.6.4c1.8 1.2 5.2 2.1 8.1 2.1 7.9 0 11.4-4.8 11.4-9.6 0-4.6-2.5-7.5-8.2-9.8-4-1.6-5.3-2.7-5.3-4.9 0-1.6 1.2-3.5 4.6-3.5 2.3 0 4.1.7 5.2 1.3l1 .6.4-1.1 1.1-3.2.3-.8-.7-.4c-1-.6-3.3-1.6-7-1.6z"
  }))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgJavascript1);
export default __webpack_public_path__ + "static/media/javascript1.e6df327d9e6f1eea29dc2cf6619423d6.svg";
export { ForwardRef as ReactComponent };